import { EventEmitter, Injectable, Injector } from '@angular/core';
import { UserInfo } from '@heda/core-util';
import { AfterLoginHandler } from '@heda/core-hospital-ui';
import { IntegrationService } from 'app/integration/integration.service';
import { MessageService } from '@heda/core-hospital-ui';
import { IesterUtilService } from '@heda/core-hospital-ui';

@Injectable()
export class HedaAuthHandler implements AfterLoginHandler {
  public constructor(
    private integrationService: IntegrationService,
    private injector: Injector,
    private iesterUtilService: IesterUtilService
  ) {}

  doAfterLogin(userInfo: UserInfo) {
    this.integrationService.isHedesterEnabled().subscribe((hedesterEnabled) => {
      if (hedesterEnabled) {
        if (!userInfo['iester']) {
          userInfo['iester'] = [];
        }
      }
    });
    this.validatePractitioner(userInfo);
  }

  registerLogout(onLogout: EventEmitter<any>) {
    onLogout.subscribe(() => this.iesterUtilService.iesterLogout());
  }

  //FIXME: move to separate service
  validatePractitioner(userInfo: UserInfo) {
    // this hedester check shouln't be necessary but no error message is shown without it
    this.integrationService.isHedesterEnabled().subscribe(() => {
      if (!userInfo.reference || !userInfo.reference.practitioner || !userInfo.reference.practitioner.id) {
        this.injector.get(MessageService).error('auth.error.missing-practitioner', {
          'est-id': userInfo.getUserIdentifier('est-id'),
          sub: userInfo.getUserIdentifier('sub'),
        });
        this.removeGeneralPrivileges(userInfo);
      }
    });
  }

  private removeGeneralPrivileges(userInfo: UserInfo) {
    if (!userInfo.account || !userInfo.account.privileges) {
      return;
    }
    [
      'death.view',
      'rec.out.booking',
      'rec.out.reception',
      'enc.out.practitioner',
      'emergency.department',
      'inpatient.department',
      'inpatient.registration',
    ].forEach((item) => {
      delete userInfo.account.privileges[item];
    });
  }
}
